/*!
 * ymm-results.js — collection "results banner". When a garage vehicle is active, shows "Showing parts for
 * your <bike>" with a one-click "See only parts that fit" (adds ?filter.p.tag=<fitTag>) / "Show all" toggle.
 * The per-card fit badges (ymm-badges.js) handle precise annotation. Mount: [data-ymm-results-banner].
 */
(function (w) {
  'use strict';
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  // Fitment landing page + a DIFFERENT bike in the garage. The page's own copy already names its bike,
  // so restating "showing parts for your <garage bike>" here was flatly wrong — it contradicted the H1.
  // Instead: name both bikes and hand them a link to THEIR bike's own landing page. Deliberately does not
  // touch the garage — they chose that bike, and a page they merely landed on shouldn't overwrite it.
  function renderSwitch(mount, pageVeh, garage) {
    mount.hidden = false;
    var box = el('div', 'ymm-resultbar ymm-resultbar--switch');
    box.innerHTML = '<span class="ymm-resultbar__ico">🏍</span><span class="ymm-resultbar__msg">' +
      'Showing parts for a <strong>' + esc(pageVeh.label) + '</strong> — your bike is a <strong>' +
      esc(garage.label) + '</strong>.</span>';

    // TWO ways out, because there are two reasons to be here and we can't know which (Joe, 2026-07-16:
    // "should have something that says 'change your bike to 2024' (easy change) to my garage").
    //   • "Make this my bike"        — you came here on purpose; adopt the page's bike.
    //   • "See parts for your <bike>" — you landed here by accident; go back to what you own.
    // Adopting is an explicit CLICK, never automatic: a page you merely landed on must not silently
    // overwrite the bike you chose. Offering it is not the same as doing it.
    var swap = el('button', 'ymm-resultbar__btn ymm-resultbar__btn--swap');
    swap.type = 'button';
    swap.textContent = 'Make the ' + pageVeh.label + ' my bike';
    swap.addEventListener('click', function () {
      if (w.YMMGarage) w.YMMGarage.set(pageVeh);   // fires ymm:garage → badges/groups/banner all re-render
    });
    box.appendChild(swap);

    var a = el('a', 'ymm-resultbar__btn ymm-resultbar__btn--ghost');
    a.href = w.YMM.fitUrl(garage, w.YMM_FIT_COLLECTIONS, '/collections/all');
    a.textContent = 'See parts for your ' + garage.label + ' →';
    box.appendChild(a);
    mount.appendChild(box);
  }

  function render(mount, counts) {
    if (!w.YMM || !w.YMM.engine) return;
    var veh = w.YMMGarage && w.YMMGarage.get();
    var pageVeh = w.YMM.pageVehicle && w.YMM.pageVehicle();
    mount.innerHTML = '';
    if (pageVeh) {
      // no garage, or the garage bike IS this page's bike → the page copy says it all, stay quiet
      var same = veh && w.YMM.collectionHandle(veh) === w.YMM.collectionHandle(pageVeh);
      if (!veh || same) { mount.hidden = true; return; }
      renderSwitch(mount, pageVeh, veh);
      return;
    }
    if (!veh) { mount.hidden = true; return; }
    mount.hidden = false;
    var box = el('div', 'ymm-resultbar');
    // No "see only parts that fit" toggle any more — nothing is hidden, so it had nothing to toggle.
    // The grid is grouped instead: fits → universal → doesn't fit. Just report what fits.
    // Same keyword treatment as the counted line below — this is what shows in the moment before the
    // badges report their counts, so it can't be the one line that omits the brand and category.
    var msg = 'Showing HogPlay Motorcycle Media parts for your <strong>' + esc(veh.label) + '</strong>';
    if (counts && counts.shown != null) {
      // "HogPlay Motorcycle Media parts" not "parts" — Joe, 2026-07-16: keyword-rich. This banner is the
      // first line of copy on the results page and it named the bike but never the brand or the category.
      // Verb agrees with the count: "1 … part fits your", "12 … parts fit your". The old line said
      // "1 part fit your" — it pluralised the noun and left the verb behind.
      msg = '<strong>' + counts.shown + '</strong> HogPlay Motorcycle Media part' +
        (counts.shown === 1 ? ' fits' : 's fit') +
        ' your <strong>' + esc(veh.label) + '</strong>' +
        (counts.nofit ? ' · ' + counts.nofit + ' below don\'t' : '');
    }
    box.innerHTML = '<span class="ymm-resultbar__ico">🏍</span><span class="ymm-resultbar__msg">' + msg + '</span>';
    mount.appendChild(box);
  }

  function boot() {
    var mount = document.querySelector('[data-ymm-results-banner]');
    if (!mount) return;
    var last = null;
    // badges may have already run before this listener attached — ask for a refresh so we get live counts
    if (w.YMM) w.YMM.onReady(function () { render(mount, last); if (w.YMMBadges) w.YMMBadges.refresh(); });
    document.addEventListener('ymm:garage', function () { render(mount, last); });
    // badges report how many fit/were hidden — re-render the banner with live counts
    document.addEventListener('ymm:badges', function (e) { last = e.detail; render(mount, last); });
  }
  document.addEventListener('DOMContentLoaded', boot);
})(window);
